import { Box, Typography } from "@mui/material";
import LogoImageOnly from "@core/components/LogoImageOnly";

const MobileUnavailableScreen: React.FC = () => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh",
                textAlign: "center",
                gap: 2,
                p: 4,
            }}
        >
            <LogoImageOnly size={100} />
            <Typography variant="h4" gutterBottom>
                Diese Anwendung ist noch nicht für mobile Geräte verfügbar
            </Typography>
            <Typography variant="body1">
                Bitte besuche diese Seite auf einem Desktop- oder Laptop-Gerät.
            </Typography>
        </Box>
    );
};

export default MobileUnavailableScreen; 